// import { SampleA } from './openProjects/components';
import { OpenProject } from './openProjects/components';

/**
 * Features
 */
export const Features = [new OpenProject()];
